
"use client"

import { Button, Col, InputNumber, Popover, Radio, Row, Select } from "antd"

import Title from "@/components/common/Typography/Title"
import Text from "@/components/common/Typography/Text"
import { MinusOutlined, PlusOutlined } from "@ant-design/icons"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { flightActions } from "@/lib/redux/features/flight/reduce"
import { useTranslation } from "react-i18next"

const InputInfant = () => {
  const inputAdult = useAppSelector(state => state.flight.inputAdult || 0)
  const inputChildren = useAppSelector(state => state.flight.inputChildren || 0)
  const inputInfant = useAppSelector(state => state.flight.inputInfant || 0)
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const max = 9 - inputAdult - inputChildren

  return (
    <Row gutter={[24, 8]} style={{ marginBlock: '1rem' }} justify='space-between' align='middle'>
      <Col>
        <Row>
          <Title level={5} style={{ margin: 0 }}>{t("common.infant")}</Title>
        </Row>
        <Row>
          <Text type='secondary'>{t("common.infant_rule", { max: 2 })}</Text>
        </Row>
      </Col>
      <Col>
        <Row align='middle' gutter={[5, 5]}>
          <Col>
            <Button disabled={inputInfant === 0} onClick={() => dispatch(flightActions.inputInfant(inputInfant - 1))} shape='circle' icon={<MinusOutlined />} />
          </Col>
          <Col>
            <InputNumber max={max} min={0} onChange={(v) => dispatch(flightActions.inputInfant(v))} value={inputInfant} variant='borderless' controls={false} size='middle' style={{ maxWidth: 36 }} />
          </Col>
          <Col>
            <Button disabled={inputInfant >= inputAdult || inputInfant >= max} onClick={() => dispatch(flightActions.inputInfant(inputInfant + 1))} shape='circle' icon={<PlusOutlined />} />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default InputInfant